import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { ResponseError } from 'models/common/respone.model';
import { RoleMaster } from 'models/role';

export function useAddMasterRole(
    options?: UseMutationOptions<
        ResponseError,
        AxiosError<ResponseError>,
        RoleMaster
    >
) {
    return useMutation({
        mutationFn: request => {
            const accessToken = localStorage.getItem('WF_APPLICATION');
            return axios.post('/v1/configuration/workflow/role', request, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
        },
        ...options
    });
}
